<template>
  <CModal
    :show.sync="show"
    @close="close"
    :close-on-backdrop="false"
    centered
  >
    <template #header>
      <div>
        <div class="d-flex align-items-start">
          <CIcon name="cipBriefcase01" size="custom-size" width="36" height="36"
                 class="mr-3 icon-circle icon-circle--primary"/>
          <div>
            <h5 class="modal-title mb-0">
              <translate translate-context="payout.certification">Company data</translate>
            </h5>
            <p class="m-0">
              <translate translate-context="payout.certification">
                Fill in the required fields to certify your company and enable payments.
              </translate>
            </p>
          </div>
        </div>
      </div>
      <div>
        <CButtonClose @click="close"/>
      </div>
    </template>

    <template #default>
      <PAlert v-if="isPending" icon="cipInfo" color="info" class="mb-3">
        <translate translate-context="payout.certification">
          Your certification is being reviewed. You will be notified once it is approved.
        </translate>
      </PAlert>
      <PAlert v-if="isRejected" icon="cipInfo" color="danger" class="mb-3">
        <div>
          <translate translate-context="payout.certification">
            Your certification has been rejected. Please review and resubmit.
          </translate>
        </div>
        <div v-if="rejectedReason" class="mt-1 font-weight-medium">
          {{ rejectedReason }}
        </div>
      </PAlert>
      <CForm @submit.prevent="handleSubmit">
        <VatDataForm
          v-if="selectedCmId"
          ref="vatDataForm"
          v-model="form"
          :disabled="isReadOnly"
          :contract-manager-id="selectedCmId"
          @validity-change="onVatDataFormValidity"
        />
      </CForm>
    </template>

    <template #footer>
      <CButton color="secondary" @click="close">
        <translate translate-context="payout.certification">Close</translate>
      </CButton>
      <CButton
        v-if="!isPending"
        color="primary"
        @click="handleSubmit"
        :disabled="isReadOnly || !vatDataFormValid || isSubmitting"
      >
        <CSpinner v-if="isSubmitting" size="sm" class="mr-2" />
        <translate translate-context="payout.certification">Confirm</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import { mapGetters } from 'vuex'
import VatDataForm from '@/components/VatDataForm.vue'
import PAlert from '@/components/PAlert.vue'
import { CERTIFICATION_STATUS } from '../constants'

export default {
  name: 'CertificationModal',
  components: { VatDataForm, PAlert },
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    },
    canSubmit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('payout', ['selectedCmId']),
    isPending() {
      return this.certificationStatus === CERTIFICATION_STATUS.PENDING
    },
    isRejected() {
      return this.certificationStatus === CERTIFICATION_STATUS.REJECTED
    },
    isReadOnly() {
      return !this.canSubmit || this.isPending
    }
  },
  data() {
    return {
      show: false,
      vatDataFormValid: false,
      certificationStatus: null,
      rejectedReason: null,
      form: {
        region: 'eu',
        document: null,
        vat_number: ''
      }
    }
  },
  methods: {
    onVatDataFormValidity(valid) {
      this.vatDataFormValid = valid
    },

    open(certification = null) {
      if (certification) {
        this.certificationStatus = certification.status || null
        this.rejectedReason = certification.rejected_reason || null
        this.form = {
          region: certification.region || 'eu',
          vat_number: certification.vat_number || '',
          document: certification.document || null
        }
      } else {
        this.certificationStatus = null
        this.rejectedReason = null
        this.form = {
          region: 'eu',
          vat_number: '',
          document: null
        }
      }
      this.show = true
    },

    close() {
      this.show = false
    },

    handleSubmit() {
      if (!this.vatDataFormValid || this.isReadOnly) return

      const formData = this.$refs.vatDataForm.getFormData()
      this.$emit('submit', formData)
    }
  }
}
</script>
